import { render, staticRenderFns } from "./DateOfBirthInput.vue?vue&type=template&id=0b1a2899&"
import script from "./DateOfBirthInput.vue?vue&type=script&lang=js&"
export * from "./DateOfBirthInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports